module.exports = __webpack_public_path__ + "static/media/Tournament_Visual.0af5ecd9.png";